import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';

import Labeled from '@/modules/AdminTools/components/Labeled';
import { useAreaPlan } from '../AreaContext';
import AddPricing from './AddPricing';
import PricingsTable from './PricingsTable';

const AreaPlanPricings = ({ LevelsHeader, required = true }) => {
  const areaName = useAreaPlan();
  let name = 'area_plan_pricings';
  if (areaName) {
    name = `${areaName}.${name}`;
  }

  const pricings = useFieldArray({ name });

  const append = () => {
    const pricing = {
      plan_pricing_level_id: '',
    };

    pricings.append(pricing);
  };

  const removeConfirm = (index) => {
    if (window.confirm('Are you sure?')) {
      pricings.remove(index);
    }
  };

  return (
    <Labeled label={<LevelsHeader />}>
      <PricingsTable
        pricings={pricings.fields}
        remove={removeConfirm}
        required={required}
      />
      <AddPricing {...{ append }} />
    </Labeled>
  );
};

AreaPlanPricings.propTypes = {
  LevelsHeader: PropTypes.elementType.isRequired,
  required: PropTypes.bool,
};

export default AreaPlanPricings;
